(function ($) {
  'use strict';

  if (!$) return;

  $(document).on('click', '.customizee_btn', function () {
    $('#overlay').fadeIn();
    $('.customization_popup').css('display', 'flex').hide().fadeIn();
  });

  $(document).on('click', 'span.closeee', function () {
    if ($('.CustomCheckbox_customCheckboxContainer input:checked').length > 0) {
      $('.second_popup').fadeIn();
      $('#overlay').css('z-index', '999');
      return;
    }

    $('.customization_popup, #overlay').fadeOut();
  });

  $(document).on('click', 'span.exit-btn', function () {
    $('#overlay').css('z-index', '9');
    $('.second_popup').fadeOut();
  });

  $(document).on('click', 'span.yes_want', function () {
    $('.customization_popup, #overlay').fadeOut();
    $('.second_popup').fadeOut();
    $('#overlay').css('z-index', '9');
    $('.CustomCheckbox_customCheckboxContainer input').prop('checked', false);
    $('.twopoint input.input-customizeation').prop('disabled', true);
    $('.twopoint input.input-customizeation').val('');
    $('span.counttt').html('0');
  });
})(window.jQuery);

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 767) return;

  const header = document.querySelector("sticky-header");

  if (!header) return;

  const headerHeight = header.offsetHeight;

  function stickyHeader() {
    if (window.scrollY > 0) {
      header.classList.add("mobile-fixed-header");
      document.body.style.paddingTop = headerHeight + "px";
    } else {
      header.classList.remove("mobile-fixed-header");
      document.body.style.paddingTop = "";
    }
  }

  stickyHeader();
  window.addEventListener("scroll", stickyHeader);

});
